/* ==========================================================================
   BEN'SHOME HELP WIDGET

   Six topics, because "which size" was never the only question people arrive
   with. Someone chasing a parcel does not want a sizing quiz, and someone
   asking what the board is made of should not have to open a contact form.

   Everything here is answered from facts on file. Nothing is generated, nothing
   is guessed. If a question falls outside these six, the widget hands over to a
   person rather than inventing an answer, which is the single most important
   rule for a support bot on a store this size: a confident wrong answer about
   sizing costs a return, and about shipping costs a chargeback.

   Self-contained on purpose. It builds its own launcher and panel, so it works
   whether or not the theme section rendered any markup.
   ========================================================================== */
(function(){
  if (window.__bhHelpLoaded) return;
  window.__bhHelpLoaded = true;

  var CFG = window.BH_HELP || {};
  var URLS = {
    finder:  CFG.finder  || '/pages/find-my-size',
    guide:   CFG.guide   || '/pages/measuring-guide',
    contact: CFG.contact || '/pages/contact',
    track:   CFG.track   || '/pages/track-your-order',
    reviews: CFG.reviews || '/pages/reviews',
    about:   CFG.about   || '/pages/our-story',
    faq:     CFG.faq     || '/pages/faqs',
    warranty:CFG.warranty|| '/pages/warranty',
    shipping:CFG.shipping|| '/policies/shipping-policy',
    returns: CFG.returns || '/policies/refund-policy',
    stockist:CFG.stockist|| ''
  };

  function a(href, text){ return '<a href="' + href + '">' + text + '</a>'; }

  var TOPICS = [
    {
      id: 'size',
      label: 'Which size fits my sofa',
      body:
        '<p>The size finder does the matching for you. Pick your furniture, then choose your seat width and depth from the ranges we make. No typing, no guessing.</p>' +
        '<p><b>One thing before you measure:</b> take the cushions off first. You want the bare seat deck, arm to arm and front edge straight back. Cushions overhang the frame, and measuring those is what sends people the wrong size.</p>' +
        '<p>If your number falls between two ranges, take the smaller one. A board that overhangs the deck will not sit flat.</p>',
      actions: [
        ['Find my size', URLS.finder, 'primary'],
        ['How to measure', URLS.guide],
        ['Send us your measurements', URLS.contact]
      ]
    },
    {
      id: 'product',
      label: 'The product and what it is made of',
      body:
        '<p><b>Half-inch solid wood panels</b> under a bound fabric cover. Not foam. Foam compresses again within months, which is how the seat went soft in the first place.</p>' +
        '<p><b>Holds 400 lb</b> across the product, over 280 lb on a single board.</p>' +
        '<p>The fabric cover has finished edges so bare wood never touches your upholstery, and it gives the cushions something to grip rather than slide on.</p>' +
        '<p>It folds flat to ship and opens across the whole seat. Fitting takes about a minute: lift the cushions, lay it on the deck, put them back. No tools, nothing attached to the sofa, and nobody can see it once the cushions are on.</p>' +
        '<p><b>Worth being straight about:</b> it helps when the support under the cushions has gone soft. It will not rescue a cracked frame or snapped springs, and it makes the seat firmer than it was.</p>',
      actions: [
        ['Warranty details', URLS.warranty],
        ['All the questions', URLS.faq],
        ['Find my size', URLS.finder, 'primary']
      ]
    },
    {
      id: 'order',
      label: 'Help with an order I placed',
      body:
        '<p>Tracking is emailed automatically the moment your order ships, so check your inbox and your spam folder first.</p>' +
        '<p>If something is wrong with the order, message us with your <b>order number</b> and we will pull it up. It is on your confirmation email and starts with a #.</p>' +
        '<p><b>Returns:</b> thirty days. Return postage is at your cost, and the refund goes out as soon as it arrives back in good condition.</p>' +
        '<p><b>Warranty:</b> if the board itself cracks, splits or comes apart, we replace it free for as long as you own it. Send a photo. You keep the old one, there is nothing to ship back.</p>',
      actions: [
        ['Track my order', URLS.track, 'primary'],
        ['Message us', URLS.contact],
        ['Returns policy', URLS.returns]
      ]
    },
    {
      id: 'shipping',
      label: 'Shipping and delivery',
      body:
        '<p><b>Free shipping</b> on every order, no minimum.</p>' +
        '<p>Usually about <b>five business days</b>. Tracking is emailed when it ships.</p>' +
        '<p>We ship to the <b>48 contiguous states and DC</b>. We do not currently ship to Alaska, Hawaii or military addresses.</p>',
      actions: [
        ['Shipping policy', URLS.shipping],
        ['Track my order', URLS.track],
        ['Ask us something', URLS.contact]
      ]
    },
    {
      id: 'where',
      label: 'Where else can I buy',
      body:
        '<p>Buying here is the most direct route: same product, same warranty, and our team handles it from start to finish.</p>' +
        '<p>We also sell on our marketplace storefront, which is where most of our reviews were left. If you already have an account there and prefer it, that is completely fine by us.</p>' +
        '<p>We are not sold through third-party resellers. If you see our boards somewhere we have not mentioned, the warranty may not apply, so message us and we will confirm.</p>',
      actions: URLS.stockist
        ? [['Our storefront', URLS.stockist], ['Read the reviews', URLS.reviews], ['Buy here', URLS.finder, 'primary']]
        : [['Read the reviews', URLS.reviews], ['Buy here', URLS.finder, 'primary'], ['Ask us', URLS.contact]]
    },
    {
      id: 'company',
      label: 'About BEN’SHOME',
      body:
        '<p>We started in 2019 because there was no good answer to a sagging sofa short of replacing it. We were first to bring this product to the market, and plenty of others followed.</p>' +
        '<p>Since then: over <b>500,000 orders</b> and <b>9,124 verified reviews</b>.</p>' +
        '<p>The company is <b>DBZ WORKS INC.</b>, based in Florida. Real people answer the messages, usually the same business day.</p>',
      actions: [
        ['Our story', URLS.about],
        ['Read the reviews', URLS.reviews],
        ['Contact us', URLS.contact]
      ]
    }
  ];

  /* ---------- markup ---------- */
  var wrap = document.createElement('div');
  wrap.className = 'bhw';
  wrap.innerHTML =
    '<button class="bhw-launch" type="button" aria-expanded="false" aria-controls="bhwPanel">' +
      '<span>Need a hand?</span></button>' +
    '<div class="bhw-panel" id="bhwPanel" role="dialog" aria-label="Help" hidden>' +
      '<div class="bhw-head">' +
        '<button class="bhw-back" type="button" hidden aria-label="Back">&#8592;</button>' +
        '<div><b>How can we help?</b><small>Real answers, no runaround</small></div>' +
        '<button class="bhw-x" type="button" aria-label="Close">&#215;</button>' +
      '</div>' +
      '<div class="bhw-body"></div>' +
      '<p class="bhw-foot">Anything not covered here, a person will answer. Usually the same business day.</p>' +
    '</div>';
  document.body.appendChild(wrap);

  var launch = wrap.querySelector('.bhw-launch');
  var panel  = wrap.querySelector('.bhw-panel');
  var body   = wrap.querySelector('.bhw-body');
  var back   = wrap.querySelector('.bhw-back');

  function menu(){
    back.hidden = true;
    body.innerHTML = '<ul class="bhw-menu">' + TOPICS.map(function(t){
      return '<li><button type="button" data-topic="' + t.id + '">' + t.label + '</button></li>';
    }).join('') + '</ul>';
  }

  function show(id){
    var t = TOPICS.filter(function(x){ return x.id === id; })[0];
    if(!t) return;
    back.hidden = false;
    body.innerHTML =
      '<h4 class="bhw-title">' + t.label + '</h4>' +
      '<div class="bhw-copy">' + t.body + '</div>' +
      '<div class="bhw-actions">' + t.actions.map(function(x){
        return '<a class="btn ' + (x[2] === 'primary' ? 'btn-primary' : 'btn-secondary') +
               '" href="' + x[1] + '">' + x[0] + '</a>';
      }).join('') + '</div>';
    if (typeof window.bhTrack === 'function') window.bhTrack('bh_help_topic', {topic: id});
  }

  function open(on){
    panel.hidden = !on;
    launch.setAttribute('aria-expanded', on ? 'true' : 'false');
    if(on){ menu(); if (typeof window.bhTrack === 'function') window.bhTrack('bh_help_open', {}); }
  }

  launch.addEventListener('click', function(){ open(panel.hidden); });
  wrap.querySelector('.bhw-x').addEventListener('click', function(){ open(false); });
  back.addEventListener('click', menu);
  body.addEventListener('click', function(e){
    var b = e.target.closest('button[data-topic]');
    if(b) show(b.dataset.topic);
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !panel.hidden){ open(false); launch.focus(); }
  });
})();
